<template>
    <div class="mh-box">
        <div class="moduleHeader">
            <router-link tag="span" to="/" class="home"><i class="material-icons">home</i>{{ text.home }}</router-link><span class="sep">|</span><span class="currentModule" @click="back">{{ moduleName }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['moduleName', 'moduleRoute'],
    computed: {
        text(){
            return this.$texts[this.$i18n.locale].moduleHeader
        }
    },
    methods: {
        back(){
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>

    * {
        font-size: 0.9rem;
    }

    .mh-box {
        height: vh(6);
    }
    .moduleHeader {
        background-color: $background-dark;
        height: vh(6);
        display: flex;
        padding: 0 3vw;
        align-items: center;
        position: fixed;
        width: 100%;

        i {
            margin-right: 6px;
        }

        * {
            color: $text-color-light;
        }

        .home {
            display: flex;
            align-items: center;
            margin-right: 5px;
            opacity: 0.8;
        }

        .sep {
            opacity: 0.8;
        }

        .currentModule {
            margin-left: 5px;
            font-weight: bold;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1280px) {
        .moduleHeader {
            height: vh(4);
        }
    }
</style>